import { Side } from '@synfutures/sdks-perp';
import React from 'react';

import { EmptyDataWrap } from '@/components/EmptyDataWrap';
import { WrappedPosition } from '@/entities/WrappedPosition';

import './index.less';

interface PositionSizeDisplayProps {
  position: WrappedPosition;
}

const PositionSizeDisplay: React.FC<PositionSizeDisplayProps> = ({ position }) => {
  return (
    <EmptyDataWrap isLoading={!position?.size}>
      <span
        className={`position-size-display ${
          position?.side === Side.LONG ? 'text-green' : position?.side === Side.SHORT ? 'text-red' : ''
        }`}>
        {position?.wrapAttribute('size').abs().formatNumberWithTooltip({
          isShowTBMK: true,
          colorShader: false,
          colorSuffix: true,
          suffix: position?.rootInstrument?.baseToken?.symbol,
        })}
      </span>
    </EmptyDataWrap>
  );
};

export default PositionSizeDisplay;
